module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("5:"), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Mètre étalon")])])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0010-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_vm._v("An original "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mètre ètalon")]), _vm._v(" bar set in the wall at 36 Rue de Vaugirard in Paris.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("N")]), _vm._v("apoleon is often credited with the establishment of metrification in France, but this is incorrect. France, just like the rest of Europe, had no countrywide system of weights and measures before the French Revolution. The same measurement could vary widely, depending on the region, city or even different trade bodies. For example, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lieue")]), _vm._v(" (or league) varied in length from 3.27 km to as much as 5.85 km in different regions. Overall, within France, because of these regional variances, it has been estimated that there were over a quarter of a million different measures used in 1791.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the Revolution, the government incorporated a metric system to unify weights and measurements across France. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mètre")]), _vm._v(" was defined in 1793 as one ten-millionth of the distance from the equator to the North Pole but this was found not to be accurate enough, as the earth is not an easily-defined shape and thus the calculation was in error. It was redefined in 1799 in terms of a platinum metre bar deposited in the National Archives. In 1889 the International Prototype Metre Bar was produced. Six metre bars, as per the one above, were set around Paris to allow people to produce their own accurate metres.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("The kilogram was introduced in 1795, although redefined in 1799 as the mass of one litre of water at 4 degrees centigrade. In 1889 the International Prototype Kilogram was produced made of a platinum-iridium alloy and kept environmentally controlled inside three bell jars, each locked by a ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("key held by a different person. It is kept in a safe in Sèvres in Paris and every 50 years it is brought out and compared with six copies, which are then used to calibrate 34 replicas all around the world. The introduction of these metric measurements was slow and done region by region, starting with Paris, hence the standardisation was slow to happen and many resisted the change and continued using the old measures.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0011-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_vm._v("The International Prototype Kilogram.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Metric time was also introduced with ten hours per day of one hundred minutes of one hundred seconds, but it proved so unpopular that it was all but abandoned the same year and was finally abolished by Napoleon in 1806.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Napoleon was a great advocate of having a universal system of weights and measures, but he was also a traditionalist and a pragmatist and he was not a huge fan of the metric system per se. In 1812 Napoleon decreed the ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mesures Usuelles’")]), _vm._v(", which kept the metric measures, but also reintroduced a number of the ancient measures, which people refused to give up, but giving them a standard, country-wide measurement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He reintroduced the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toise")]), _vm._v(" (2 metres), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pieds, pouces")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lignes")]), _vm._v(" for distance (not unlike the Imperial feet and inches); the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aune")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ell")]), _vm._v(" (120 cm) as a measure of cloth; litres were divided into "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("demis, quarts, huitiemes")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("seiziemes")]), _vm._v(" (2 fluid ounces); the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("boisseau")]), _vm._v(" (bushel) was re-established as well as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("livre")]), _vm._v(" (or pound) as 500 grams, which divided into 16 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("onces")]), _vm._v(", each of 8 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gros")]), _vm._v(" of 72 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("grains")]), _vm._v(" each. These standardised Imperial measures remained in force until they were banned in 1839, however, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("livre")]), _vm._v(" is commonly used in France to this day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What Napoleon did do though, through the expansion of his Empire across Europe, was to expedite the metric system’s adoption by other states, although they all initially abandoned it after the fall of Napoleon in 1814. In fact, Portugal was the second country in Europe to fully apply the metric system in 1814 and Belgium and Holland (then a joint kingdom) followed in 1820. Spain went metric in 1852, Italy in 1861, the German states in 1868-69, Austria in 1871, Hungary in 1874 and Turkey in 1875. Today, most countries have adopted the metric system wholly or at least partially, like Britain and the United States of America.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bd08274","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter_05.vue
// module id = 87
// module chunks = 0